import React, { useState } from 'react';
import styles from './sidebar.module.scss';
import { Link } from 'react-router-dom';
import { Button, IconButton, Badge } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
// import { ExitButton } from './components/exitDialog';
import { ExitButton } from './exitDialog';
import { useTranslation } from 'react-i18next';
import VideoTutorialDialog from 'src/pages/VideoTutorials';

export const DesktopSidebar = ({ signOut, countNotification, buttonList, selectedView, setSelectedView, accountType }) => {
    const [openMenu, setOpenMenu] = useState(true);
    const { t } = useTranslation();

    return (
        <div className={[styles['sidebarContainer'], !openMenu ? styles['sidebarContainer-close'] : null].join(' ')}>
            <div className={styles['sidebarContainer__icon-back']}>
                <IconButton className={styles['sidebarContainer__icon-button']} size="small" onClick={() => setOpenMenu(!openMenu)}>
                    {openMenu ? <ChevronLeftIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
                </IconButton>
            </div>
            <div className={styles['menuContainer']}>
                {
                    buttonList.map(({ icon, title, linkTo, section }, index) =>
                        section === 'default' && (
                            <Link onClick={() => setSelectedView(linkTo)} to={'/' + linkTo} key={index} className={linkTo === selectedView ? styles['menuContainer__activeLink'] : styles['menuContainer__link']}>
                                <Button key={title} className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}`]}>
                                    {index === 0 ? <Badge badgeContent={parseInt(countNotification)} color="error" className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Icon`]}>{icon}</Badge> : <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Icon`]}>{icon}</div>}
                                    {openMenu ? <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Title`]}>{t(`sidebar:${title}`)}</div> : null}
                                </Button>
                            </Link>
                        )
                    )
                }
                {
                    buttonList.map(el => el['section']).indexOf('administration') > -1 ?
                        <div className={styles['menuContainer-administration']}>
                            <div className={styles['menuContainer-administration__title']} style={openMenu ? null : { opacity: 0 }}>{t('sidebar:administration')}</div>
                            {
                                buttonList.map(({ icon, title, linkTo, section }, index) =>
                                    section === 'administration' && (
                                        <Link onClick={() => setSelectedView(linkTo)} to={'/' + linkTo} key={index} className={linkTo === selectedView ? styles['menuContainer__activeLink'] : styles['menuContainer__link']}>
                                            <Button key={title} className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}`]}>
                                                <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Icon`]}>{icon}</div>
                                                {openMenu ? <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Title`]}>{t(`sidebar:${title}`)}</div> : null}
                                            </Button>
                                        </Link>
                                    )
                                )
                            }
                        </div>
                        : null
                }
                {accountType !== 'SPONSOR' && <div className={styles['menuContainer-administration']}>
                    <div className={styles['menuContainer-administration__title']} style={openMenu ? null : { opacity: 0 }}>{t('sidebar:others')}</div>
                    <VideoTutorialDialog openMenu={openMenu} className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}`]} customStyles={{ textButton: styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Title`], icon: styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Icon`] }} />

                    {
                        buttonList.map(({ icon, title, linkTo, section }, index) =>
                            section === 'others' && (
                                <Link onClick={() => setSelectedView(linkTo)} to={'/' + linkTo} key={index} className={linkTo === selectedView ? styles['menuContainer__activeLink'] : styles['menuContainer__link']}>
                                    <Button key={title} className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}`]}>
                                        <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Icon`]}>{icon}</div>
                                        {openMenu ? <div className={styles[`menuContainer__menu${openMenu ? 'Expanded' : ''}-Title`]}>{t(`sidebar:${title}`)}</div> : null}
                                    </Button>
                                </Link>
                            )
                        )
                    }
                </div>}
                <div className={styles['menuContainer__logoutContainer']}>
                    <div className={styles['menuContainer__logoutContainer-button']}>
                        <ExitButton styles={styles} openMenu={openMenu} logout={signOut} />
                    </div>
                </div>
            </div>
        </div>
    )
}